import React, { useState, useEffect } from "react";
import { Col, Row } from "antd";
import Request from "../../helpers/Request";
import ReviewCard from "./components/ReviewCard";
import type { Review } from "./components/ReviewCard";

const ReviewsSection = () => {
  const [reviews, setReviews] = useState<Review[]>([]);

  useEffect(() => {
    Request("../reviews_list", "GET").then((response) => {
      setReviews(response.data);
    });
  }, []);

  return (
    <>
      {reviews.length > 0 && (
        <div className="reviews-section">
          <Row gutter={[16, 16]}>
            {reviews.map((review, index) => (
              <Col key={index} xs={24} sm={24} md={12} lg={8} xl={8}>
                <ReviewCard review={review} />
              </Col>
            ))}
          </Row>
        </div>
      )}
    </>
  );
};

export default ReviewsSection;
